const formatVehicleTitle = (extItem) => {
  const { model } = extItem.data;
  return (model == null ? void 0 : model.displayName) ?? "";
};
export {
  formatVehicleTitle
};
